###*
  * Allows to render JSON object as HTML table
###

class INTENT.report.Renderer

  constructor: (@controller) ->
    @code = @controller.code + '-renderer'
    @attr = @controller.attr + '-renderer'

  render: (response) =>
    html = ''
    if response.error or !response.query? or !response.data?
      html = @get_alert_html 'error', response.message || __('livereport.error.occurred')
    else if !_.isArray(response.data.data) or !response.data.data.length
      html = @get_alert_html 'info', __('livereport.error.data.empty')
    else
      html = @get_table_html response

    @controller.tableData = response;

    $("[#{@attr}-wrapper]").html(html)
    $("[#{@attr}-table]").multiTable()

  get_alert_html: (type, message) =>
    """
      <div class="text-center alert alert-#{type} alert-no-dismiss">
        #{message}
      </div>
    """

  get_table_html: (response) =>
    # data-left-col - total count of left cols
    # data-visible-left-col - count of visible (fixed) left cols
    data = response.data

    group_keys = data.group_keys || []

    left_col_count = group_keys.length
    right_col_count = _.difference(data.fields || [], data.group_keys || []).length

    if left_col_count <= right_col_count
      left_col_visible = Math.round (left_col_count + right_col_count) * (1/3)
    else
      left_col_visible = Math.round (left_col_count + right_col_count) * (2/3)

    if left_col_visible < 2
      left_col_visible = 2
    if left_col_visible > left_col_count
      left_col_visible = left_col_count

    """
    <table data-visible-left-col="#{left_col_visible}"
           data-left-col="#{left_col_count}"
           data-report-renderer-table
    >
      #{@get_report_table_head(response)}
      #{@get_report_table_body(response)}
    </table>
    """

  get_report_table_head: (response) =>
    data = response.data
    query = response.query

    html = ''
    fields = data.fields
    if !fields or !fields.length
      return ''

    sorting = {}
    if query and _.isObject(query.order) and query.order.key? and query.order.direction in ['asc', 'desc']
        sorting.key = query.order.key
        sorting.direction = query.order.direction

    for field in fields
      td_class = 'sortable'
      if field in ['advertiser_id', 'campaign_id']
        td_class += ' multi-table__name'

      if field is sorting.key
        td_class += ' sorted'
        td_class += if sorting.direction is 'asc' then ' ascending' else ' descending'

      html += """
        <th class="#{td_class}"
            data-key="#{field}">
          <div>
            #{@controller.get_field_name(field)}
          </div>
        </th>
      """

    """
    <thead>
      <tr>
        #{html}
      </tr>
    </thead>
    """

  get_report_table_body: (response) =>
    data = response.data
    query = response.query

    fields = data.fields
    if !fields or !fields.length
      return ''

    rows = data.data
    if !rows or !rows.length
      return ''

    dataset = @controller.get_dataset query.dataset_name
    if !dataset
      return ''

    html = ''
    for row in rows
      html += "<tr>"
      index = 0
      for field_code in fields
        field_data = row[index]
        index++

        if typeof field_data is 'undefined' or field_data is null
          html += "<td><div>&nbsp;</div></td>"
        else
          td_filter = ''
          td_class = ''
          if field_code in dataset.key_fields
            td_class += 'multi-table__name'
            td_filter += """
              <a href="#" class="fa fa-filter filter-by"></a>
            """

          html += """
            <td class='#{td_class}'>
              <div>
                #{td_filter}
                #{field_data}
              </div>
            </td>
        """
      html += "</tr>"

    html_total = ''
    total_row = response.total_row
    if total_row
      for field_code in fields
        field_data = total_row[field_code]
        if typeof field_data is 'undefined' or field_data is null
          html_total += "<td><div>&nbsp;</div></td>"
        else
          html_total += """
            <td>
              <div>#{field_data}</div>
            </td>
          """

    """
    <tbody>
      <tr class="multi-table__footer">
        #{html_total}
      </tr>
      #{html}
    </tbody>
    """
